import api from '@/services/index.js'

async function fetchCaskback(callback) {
  await api
    .get('/user-profile-composite/v1/history/deposit')
    .then((v) => {
      if (v.success == true) {
        // var tranAll = v.data.Transaction.filter(
        //   (x) =>
        //     x.TransType == 'DEPOSIT' ||
        //     x.TransType == 'AFFILIATE' ||
        //     x.TransType == 'CASHBACK' ||
        //     x.TransType == 'WITHDRAW'
        // )
        var tran = v.data.Transaction.filter(
          (x) =>
            // x.TransType == 'DEPOSIT' ||
            // x.TransType == 'AFFILIATE' ||
            x.TransType == 'CASHBACK'
        )
        callback({ status: true, data: tran, message: v.message })
      } else {
        callback({ status: false, data: '', message: v.message })
      }
    })
    .catch((e) => {
      callback({ status: false, data: '', message: e.message })
    })
    .finally(() => {})
}
async function fetchRolling(callback) {
  await api
    .get('/rolling-composite/v1/get-rolling')
    .then((v) => {
      callback({ status: true, data: v.data, message: v.message })
    })
    .catch((e) => {
      callback({ status: false, data: '', message: e.message })
    })
    .finally(() => {})
}

async function Redeem(redeem_code, callback) {
  await api
    .post('/user-profile-composite/v1/topup/itemcode/redeem', {
      redeem_code: redeem_code,
    })
    .then((v) => {
      if (v.success == true) {
        callback({ status: true, data: v.data, message: v.message })
      } else {
        callback({ status: false, data: '', message: v.message })
      }
    })
    .catch((e) => {
      callback({ status: false, data: '', message: e.message })
    })
    .finally(() => {})
}

async function Rolling(income, callback) {
  if (income <= 0) {
    callback({
      status: false,
      data: '',
      message: 'คุณไม่มียอดเสีย ไม่สามารถกดรับได้',
    })
  } else {
    await api
      .get('/user-profile-composite/v1/users/cashback/vertify')
      .then((v) => {
        if (v.success == true) {
          callback({ status: true, data: v.data, message: v.message })
        } else {
          callback({ status: false, data: '', message: v.message })
        }
      })
      .catch((e) => {
        callback({ status: false, data: '', message: e.message })
      })
      .finally(() => {})
  }
}
export { fetchCaskback, fetchRolling, Rolling, Redeem }



// WEBPACK FOOTER //
// ./src/services/modules/cashback.js